export const DEFAULT_PAGE_SIZE = 20;
export const POLLING_INTERVAL = 2000;
export const STATS_POLLING_INTERVAL = 30000;
export const REQUEST_TIMEOUT = 70000; // must exceed the backend 60s per-branch Go timeout on wallet/branches
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
